import React, { FC, useState } from "react";
import { Box, SxProps, Tooltip, IconButton } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { CustomTooltip } from "./ESRQuestionLabel";

type Props = {
	name: string;
	color?: string;
	sx?: SxProps;
	handleOnClick?: () => void;
};
export const Avatar: FC<Props> = ({
	name,
	sx,
	color = "#5A9F2F",
	handleOnClick,
}) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	let label = name;
	if (name !== "...") {
		const nameParts = name
			.toUpperCase()
			.split("<")[0]
			.split(" ")
			.filter((entry) => entry !== "");
		if (nameParts.length > 1) {
			if (nameParts[nameParts.length - 1][0] === "(") {
				if (nameParts.length > 2) {
					// Avoid the (Group) part of group names
					label = nameParts[0][0] + nameParts[nameParts.length - 2][0];
				} else {
					label = nameParts[0][0];
				}
			} else {
				label = nameParts[0][0] + nameParts[nameParts.length - 1][0];
			}
		} else if (nameParts.length > 0) {
			label = nameParts[0][0];
		}
	}
	const hover = name === "..." ? "see more" : name;

	return (
		<Tooltip
			arrow
			placement="top"
			sx={{
				backgroundColor: "white",
				color: "black",
				fontSize: "2rem",
				borderRadius: "4px",
				padding: "4px",
			}}
			title={
				<>
					{isHovered}
					<span>{hover}</span>
				</>
			}
		>
			<div
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onClick={handleOnClick}
				style={{
					display: "inline-block",
					width: 32,
					height: 32,
					lineHeight: "32px",
					textAlign: "center",
					color: "white",
					borderRadius: 16,
					background: color,
					position: "relative",
					overflow: "visible",
				}}
			>
				{label}
				{/*<Box*/}
				{/*    sx={{*/}
				{/*        position: "absolute",*/}
				{/*        right: "-2px",*/}
				{/*        bottom: "-2px",*/}
				{/*        width: 8,*/}
				{/*        height: 8,*/}
				{/*        borderRadius: 4,*/}
				{/*        border: "2px solid white",*/}
				{/*        background: "#2DA733",*/}
				{/*    }}*/}
				{/*/>*/}
			</div>
		</Tooltip>
	);
};
